import { DestroyRef, inject, Service } from '@angular/core';

import { ENABLE_STANDALONE_NAVIGATION } from '../../shell/navigation/standalone-navigation';
import { RUNTIME_FAILURE_EVENT } from '../../shell/runtime/failure-events';
import { MFE_HOST_ELEMENT } from '../../shell/runtime/failure-reporter';
import { FatalErrorState } from './fatal-error-state';

/**
Standalone-only: listens for the runtime-failure event `RuntimeFailureReporter`
already unconditionally dispatches on `MFE_HOST_ELEMENT` and marks
`FatalErrorState` failed when it fires.

Deliberately does not change `RuntimeErrorHandler`/`RuntimeFailureReporter`
at all — in federated mode the same dispatch happens exactly as before,
just with nobody (this listener included) reacting to it inside this MFE.
*/
@Service()
export class FatalErrorListener {
  constructor() {
    const isStandalone = inject(ENABLE_STANDALONE_NAVIGATION, { optional: true }) ?? false;

    if (!isStandalone) {
      return;
    }

    const hostElement = inject(MFE_HOST_ELEMENT);
    const fatalErrorState = inject(FatalErrorState);
    const onRuntimeFailure = (): void => {
      fatalErrorState.markFailed();
    };

    hostElement.addEventListener(RUNTIME_FAILURE_EVENT, onRuntimeFailure);
    inject(DestroyRef).onDestroy(() => {
      hostElement.removeEventListener(RUNTIME_FAILURE_EVENT, onRuntimeFailure);
    });
  }
}
